/**
 * cacheDataExplorerStyles.js — StyleSheet for CacheDataExplorer.
 * Extracted verbatim from components/CacheDataExplorer.jsx (god-file decomposition).
 */

import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    marginBottom: 15,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#E5E7EB',
    marginBottom: 5,
  },
  headerSubtitle: {
    fontSize: 13,
    color: '#9CA3AF',
  },
  searchContainer: {
    marginBottom: 12,
  },
  searchInput: {
    height: 38,
    backgroundColor: '#1F2937',
    borderRadius: 8,
    paddingHorizontal: 12,
    fontSize: 14,
    color: '#E5E7EB',
    borderWidth: 1,
    borderColor: '#374151',
  },
  advancedSearchContainer: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 12,
  },
  advancedSearchInput: {
    flex: 1,
    height: 38,
    backgroundColor: '#1F2937',
    borderRadius: 8,
    paddingHorizontal: 12,
    fontSize: 13,
    color: '#E5E7EB',
    borderWidth: 1,
    borderColor: '#374151',
  },
  leagueFilterContainer: {
    height: 40,
    marginBottom: 15,
  },
  leagueFilter: {
    flexGrow: 0,
  },
  leagueFilterContent: {
    alignItems: 'center',
    paddingVertical: 4,
  },
  leagueButton: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: '#1F2937',
    borderRadius: 6,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#374151',
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  leagueButtonActive: {
    backgroundColor: '#3B82F6',
    borderColor: '#3B82F6',
  },
  leagueButtonText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#9CA3AF',
  },
  leagueButtonTextActive: {
    color: '#FFFFFF',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
  },
  loadingText: {
    marginTop: 10,
    fontSize: 14,
    color: '#9CA3AF',
  },
  fixturesContainer: {
    flex: 1,
  },
  resultsCount: {
    fontSize: 12,
    color: '#9CA3AF',
    fontWeight: '600',
  },
  paginationInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  pageInfo: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '500',
  },
  paginationControls: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    marginBottom: 15,
    paddingVertical: 10,
    backgroundColor: '#1F2937',
    borderRadius: 8,
  },
  paginationButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#374151',
    borderRadius: 6,
    minWidth: 60,
    alignItems: 'center',
  },
  paginationButtonDisabled: {
    backgroundColor: '#1F2937',
    opacity: 0.5,
  },
  paginationButtonText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '600',
  },
  paginationPageText: {
    color: '#E5E7EB',
    fontSize: 13,
    fontWeight: '600',
    paddingHorizontal: 12,
  },
  emptyState: {
    padding: 30,
    alignItems: 'center',
  },
  emptyStateText: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
  },
  fixtureCard: {
    backgroundColor: '#1F2937',
    borderRadius: 8,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#374151',
    overflow: 'hidden',
  },
  fixtureHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
  },
  fixtureHeaderLeft: {
    flex: 1,
  },
  fixtureHeaderTop: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  fixtureLeague: {
    fontSize: 10,
    fontWeight: '700',
    color: '#3B82F6',
    marginRight: 10,
    textTransform: 'uppercase',
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#111827',
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderRadius: 4,
  },
  statusFlag: {
    fontSize: 10,
    marginRight: 4,
  },
  statusLabel: {
    fontSize: 9,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  fixtureTeams: {
    fontSize: 14,
    fontWeight: '600',
    color: '#E5E7EB',
    marginBottom: 4,
  },
  fixtureDate: {
    fontSize: 11,
    color: '#9CA3AF',
  },
  fixtureHeaderRight: {
    alignItems: 'flex-end',
  },
  marketsBadge: {
    backgroundColor: '#1E3A8A',
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 4,
    marginBottom: 5,
  },
  marketsBadgeText: {
    fontSize: 10,
    color: '#93C5FD',
    fontWeight: '600',
  },
  expandIcon: {
    fontSize: 12,
    color: '#3B82F6',
    fontWeight: 'bold',
  },
  fixtureDetails: {
    borderTopWidth: 1,
    borderTopColor: '#374151',
    paddingTop: 8,
    paddingHorizontal: 12,
    paddingBottom: 12,
  },
  noMarketsText: {
    fontSize: 12,
    color: '#6B7280',
    fontStyle: 'italic',
    textAlign: 'center',
    paddingVertical: 15,
  },
  marketCard: {
    backgroundColor: '#111827',
    borderRadius: 6,
    marginBottom: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#374151',
  },
  marketHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
  },
  marketName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#E5E7EB',
    flex: 1,
  },
  marketHeaderRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  oddsCount: {
    fontSize: 10,
    color: '#9CA3AF',
    marginRight: 8,
  },
  oddsContainer: {
    paddingHorizontal: 10,
    paddingBottom: 10,
  },
  oddRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: '#fff',
    borderRadius: 4,
    marginBottom: 4,
  },
  oddLeft: {
    flex: 1,
    marginRight: 10,
  },
  oddSelection: {
    fontSize: 13,
    fontWeight: '600',
    color: '#E5E7EB',
  },
  oddPlayer: {
    fontSize: 9,
    color: '#9CA3AF',
    marginTop: 2,
  },
  oddRight: {
    alignItems: 'flex-end',
  },
  oddPrice: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 1,
  },
  oddPricePositive: {
    color: '#10B981',
  },
  oddPriceNegative: {
    color: '#EF4444',
  },
  oddSportsbook: {
    fontSize: 10,
    color: '#9CA3AF',
    marginBottom: 1,
  },
  oddEV: {
    fontSize: 10,
    fontWeight: '600',
  },
  oddEVPositive: {
    color: '#10B981',
  },
  oddEVNegative: {
    color: '#EF4444',
  },
  oddEVNull: {
    fontSize: 10,
    color: '#6B7280',
    fontStyle: 'italic',
  },
  moreOddsText: {
    fontSize: 10,
    color: '#3B82F6',
    textAlign: 'center',
    marginTop: 8,
    fontStyle: 'italic',
  },
  loadMoreButton: {
    backgroundColor: '#1E3A8A',
    padding: 12,
    borderRadius: 8,
    marginTop: 12,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#3B82F6',
  },
  loadMoreText: {
    color: '#60A5FA',
    fontSize: 13,
    fontWeight: '600',
  },
  loadingText: {
    fontSize: 11,
    color: '#9CA3AF',
    textAlign: 'center',
    padding: 12,
    fontStyle: 'italic',
  },
  noOddsText: {
    fontSize: 11,
    color: '#6B7280',
    textAlign: 'center',
    padding: 12,
    fontStyle: 'italic',
  },
  loadingDetails: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
  },
  loadingDetailsText: {
    marginLeft: 8,
    fontSize: 12,
    color: '#9CA3AF',
  },
  // Filters styles
  filtersToggle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#1F2937',
    padding: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#374151',
    marginBottom: 12,
  },
  filtersToggleText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#E5E7EB',
  },
  filtersToggleIcon: {
    fontSize: 10,
    color: '#3B82F6',
  },
  filtersPanel: {
    backgroundColor: '#111827',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#374151',
  },
  filterSection: {
    marginBottom: 12,
  },
  filterSectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  filterLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: '#E5E7EB',
    textTransform: 'uppercase',
  },
  clearButton: {
    fontSize: 11,
    color: '#3B82F6',
    fontWeight: '600',
  },
  filterSearchInput: {
    height: 34,
    backgroundColor: '#1F2937',
    borderRadius: 6,
    paddingHorizontal: 10,
    fontSize: 12,
    color: '#E5E7EB',
    borderWidth: 1,
    borderColor: '#374151',
    marginBottom: 8,
  },
  filterTagsScrollView: {
    maxHeight: 180,
  },
  filterTagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  filterTag: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    backgroundColor: '#1F2937',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#374151',
  },
  filterTagActive: {
    backgroundColor: '#3B82F6',
    borderColor: '#3B82F6',
  },
  filterTagText: {
    fontSize: 11,
    color: '#9CA3AF',
    fontWeight: '600',
  },
  filterTagTextActive: {
    color: '#FFFFFF',
  },
  noFiltersText: {
    fontSize: 11,
    color: '#6B7280',
    fontStyle: 'italic',
  },
  moreFiltersText: {
    fontSize: 10,
    color: '#9CA3AF',
    fontStyle: 'italic',
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  clearAllButton: {
    backgroundColor: '#EF4444',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    alignItems: 'center',
    marginTop: 4,
  },
  clearAllButtonText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '700',
  },
  // Grouped odds styles
  selectionGroup: {
    backgroundColor: '#1F2937',
    borderRadius: 6,
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: '#374151',
  },
  selectionHeader: {
    marginBottom: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#374151',
  },
  sportsbooksContainer: {
    gap: 6,
  },
  sportsbookRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: '#111827',
    borderRadius: 4,
  },
  sportsbookOddsInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  sportsbookRowContainer: {
    marginBottom: 8,
  },
  mathToggleButton: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#1F2937',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#374151',
  },
  mathToggleText: {
    fontSize: 11,
    color: '#3B82F6',
    fontWeight: '600',
  },
  mathBreakdown: {
    marginTop: 8,
    padding: 12,
    backgroundColor: '#0F1419',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#374151',
  },
  mathTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#E5E7EB',
    marginBottom: 12,
  },
  mathSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    paddingVertical: 4,
  },
  mathLabel: {
    fontSize: 12,
    color: '#9CA3AF',
  },
  mathValue: {
    fontSize: 12,
    color: '#E5E7EB',
    fontWeight: '600',
  },
  mathMethodCard: {
    backgroundColor: '#1F2937',
    padding: 10,
    borderRadius: 6,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#3B82F6',
  },
  mathMethodCardActive: {
    backgroundColor: '#1E3A5F',
    borderLeftColor: '#4ADE80',
    borderWidth: 1,
    borderColor: '#4ADE80',
  },
  mathDivider: {
    height: 1,
    backgroundColor: '#374151',
    marginVertical: 12,
  },
  mathMethodTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: '#60A5FA',
    marginBottom: 6,
  },
  mathFormula: {
    fontSize: 11,
    color: '#9CA3AF',
    fontFamily: 'monospace',
    marginBottom: 4,
  },
  mathCalc: {
    fontSize: 11,
    color: '#D1D5DB',
    marginBottom: 4,
  },
  mathResult: {
    fontSize: 12,
    fontWeight: '700',
    color: '#4ADE80',
    marginTop: 4,
  },
  mathFinalResult: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#374151',
    borderRadius: 6,
    marginTop: 8,
    marginBottom: 8,
  },
  mathFinalLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: '#E5E7EB',
  },
  mathFinalSubtext: {
    fontSize: 10,
    color: '#9CA3AF',
    marginTop: 2,
  },
  mathFinalValue: {
    fontSize: 16,
    fontWeight: '700',
  },
  mathFootnote: {
    fontSize: 11,
    color: '#9CA3AF',
    fontStyle: 'italic',
    marginTop: 4,
  },
  evComparisonTable: {
    backgroundColor: '#1F2937',
    padding: 12,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: '#4ADE80',
    marginBottom: 8,
  },
  evComparisonTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#4ADE80',
    marginBottom: 12,
    textAlign: 'center',
  },
  evComparisonRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    gap: 8,
  },
  evComparisonCell: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: '#0F1419',
    padding: 10,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#374151',
  },
  evComparisonLabel: {
    fontSize: 10,
    color: '#9CA3AF',
    marginBottom: 6,
    textAlign: 'center',
  },
  evComparisonValue: {
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
  },
  evComparisonValueActive: {
    fontSize: 20,
    textShadowColor: 'rgba(74, 222, 128, 0.5)',
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 8,
  },
  evComparisonBadge: {
    fontSize: 9,
    color: '#4ADE80',
    fontWeight: '700',
    marginTop: 4,
    textAlign: 'center',
  },
  evComparisonFootnote: {
    fontSize: 10,
    color: '#9CA3AF',
    fontStyle: 'italic',
    marginTop: 10,
    textAlign: 'center',
  },
});
